import React from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card, 
  CardBody,
  CardTitle,
  Container,
  Button,
  CardSubtitle, 
} from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import "../../../src/assets/scss/datatables.scss"

export default function BranchManagement() {
  const data = {
    columns: [
      {
        label: "Business Name",
        field: "BusinessName",
        sort: "asc",
        attributes: {width:"14%"},
      },
      {
        label: "Contact Person Name",
        field: "ContactPersonName",
        sort: "asc",
        attributes: {width:"18%"},
      },
      {
        label: "Business Phone No.",
        field: "BusinessPhoneNo",
        sort: "asc",
        attributes: {width:"16%"},
      },
      {
        label: "Business Address",
        field: "BusinessAddress",
        sort: "asc",
        attributes: {width:"37%"},
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        attributes: {width:"15%"},
      },
    ],
    rows: [
      {
        BusinessName: "Bivety",
        ContactPersonName: "Nishit",
        BusinessPhoneNo: "+91 8950256893",
        BusinessAddress: "Oeder Weg 14, Frankfurt am Main Hesse, 60318, Germany",
        Action: (
          <>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="View"
              onClick={() => {}}
              href="/business-detail"
            >
              <i className="fas fa-eye"></i>
            </Button>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {}}
              href="/add-branch"
            >
              <i className="fas fa-edit"></i>
            </Button>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Delete"
              onClick={() => {}}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </Button>{" "}
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary"
              style={{
                width: "25px",
                height: "25px",
                padding: "0px",
              }}
              title="Active / Inactive"
              onClick={() => {}}
            >
              <i className="fas fa-bullseye" style={{ color: "#38e038" }}></i>
            </Button>
          </>
        ),
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Branch Management | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Button
            href="/add-branch"
            color="primary"
            style={{ float: "right", marginTop: "1.9rem" }}
          >
            Add Branch
          </Button>

          <Breadcrumbs
            maintitle="Dashboard"
            title="Branch Management"
            breadcrumbItem="Branch List"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable responsive bordered theadColor="btn-primary" noBottomColumns data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
